import { Box } from "@mui/material";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../../Hooks/useWorker";
import getMessageBody, {
  getMessageBodyId,
  messageBodiesDataId,
} from "../../../Actions/getMessageBody";
import MessageHeader from "./MessageHeader";
import MessageBody from "./MessageBody";
import MessageAttachments from "./MessageAttachments";
import {
  extractFromUserName,
  safeJSONParse,
} from "../../../Actions/utils";

// A single reply inside a card: sender + date and then the body. No subject.
// A toggle in the header swaps the simplified body for the full original one.
const ReplyMessage = ({ id, from_user, created_date_time, body, attachments }) => {
  const { auth, dispatch } = useUIBp();
  const [showFull, setShowFull] = useState(false);

  const { working } = useWorker(getMessageBodyId(id));
  const loaded = useSelector(
    (state) => state.warehouse.storage[messageBodiesDataId]?.[id] !== undefined
  );

  const onToggleBody = useCallback(() => {
    if (working) return;
    if (!loaded) {
      const controller = new AbortController();
      dispatch(getMessageBody({ ...auth, messageId: id, controller }));
      setShowFull(true);
      return;
    }
    setShowFull((v) => !v);
  }, [working, loaded, dispatch, auth, id]);

  const fromObj = safeJSONParse(from_user);
  const name = extractFromUserName(fromObj) || "—";

  return (
    <Box
      sx={{
        borderLeft: "3px solid",
        borderColor: "primary.main",
        paddingLeft: 1.5,
        paddingY: 1,
      }}
    >
      <MessageHeader
        {...{
          from_user,
          created_date_time,
          messageId: id,
          showFull,
          onToggleBody,
        }}
      />
      <Box sx={{ marginTop: 0.5 }}>
        <MessageBody
          title={name}
          body={body}
          messageId={id}
          showFull={showFull}
          maxHeight="40vh"
        />
      </Box>
      <MessageAttachments {...{ attachments }} />
    </Box>
  );
};

export default ReplyMessage;
